import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  productsSettings: {},
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setProductsSettings: (state, action) => {
      state.productsSettings = {
        ...state.productsSettings,
        ...action.payload,
      };
    }
  },
});

export const { setProducts, setProductsSettings } =
  productsSlice.actions;

export default productsSlice.reducer;
